__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/340b3d41e47b0b3c427ac7115aed2a32ad5fd0d85acabf4431a36ccd/";